import { useState, useEffect } from "react";
import UserChangeStatusPop from "./UserChangeStatusPop";

const UserComponent = ({ user }) => {
  const [userPop, setUserPop] = useState(false);
  const [status, setStatus] = useState(0);

  // using setClient Status for Update Status when load components
  useEffect(() => {
    setStatus(user.status);
  }, [user]);

  const toggleUserPop = () => {
    setUserPop((prev) => !prev);
  };

  return (
    <>
      <tr className=" bg-gray-100 border-b">
        <td className="px-6 py-4 text-gray-900 text-center font-semibold">
          <button
            className="text-blue-700 font-medium rounded-lg text-sm px-1 py-2.5 text-center"
            onClick={() => toggleUserPop()}
          >
            تغيير الحالة /
          </button>

          {status === 1 ? "مستخدم فعال" : "مستخدم غير فعال"}
          {userPop && (
            <UserChangeStatusPop user={user} setStatus={setStatus} toggleUserPop={toggleUserPop} />
          )}
        </td>
        <td className="px-6 py-4 text-gray-900 text-center font-semibold">
          {user.address === "" ? "-" : user.address}
        </td>

        <th className="px-6 py-4 text-gray-900 text-center font-semibold">{user.password}</th>

        <th className="px-6 py-4 text-gray-900 text-center font-semibold">
          {user.name == null ? "Admin" : user.name}
        </th>

        <th className="px-6 py-4 text-gray-900 text-center font-semibold">
          {user.username == null ? "Admin" : user.username}
        </th>
      </tr>
    </>
  );
};

export default UserComponent;
